import script from "./ChromeExtensionBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ChromeExtensionBanner.vue?vue&type=script&setup=true&lang=js"

import "./ChromeExtensionBanner.vue?vue&type=style&index=0&id=677b4c88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-677b4c88"]])

export default __exports__